import type { Reducer } from 'redux';

import type { CloseUpsellAction } from '../../domains/mobileUpsell/actions.types';

import type { MobileUpsell } from './types';

const initialState = {
  showMobileUpsell: true,
};

export type MobileUpsellAction = CloseUpsellAction;
const reducer: Reducer<MobileUpsell, MobileUpsellAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MOBILE_UPSELL.CLOSE_BUTTON_CLICKED':
      return { showMobileUpsell: false };
    default:
      return state;
  }
};

export default reducer;
